<template>
  <div>
    <div class="heard">
      <div style="cursor: pointer" @click="closeTip">
        <i style="font-size: 28px;display: flex;float: right" class="el-icon-close"></i>
      </div>
      <div style="width: 20%">
        <el-table
          :data="sdata"
          @row-click="getStudy_record"
          :default-sort="{prop: 'time', order: 'descending'}"
          height="700px">
          <el-table-column
            align="center"
            sortable
            prop="time"
            label="日期">
            <template slot-scope="scope"  style="cursor: pointer">
              <div> {{ scope.row.time }}</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div>
        <el-table
          width="700px"
          height="700px"
          :data="bookData"
          :row-style="{height:'63.5px'}"
          max-height="700px">
          <el-table-column
            label="序号"
            type="index"
            width="50"
            align="center">
            <template slot-scope="scope">
              <span>{{ (page - 1) * size + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="400"
            prop="file_name"
            label="文件名">
          </el-table-column>
          <el-table-column
            label="观看页数">
            <template slot-scope="scope">
              <div>
                {{ getPageCount(scope.row.index) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="是否完成">
            <template slot-scope="scope">
              <div>
                {{ getsituation(scope.row) }}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagediv">
          <el-pagination
            background
            layout="prev, pager, next, total, jumper"
            :total="total"
            :current-page="page"
            :page-size="size"
            @current-change="pagechange">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as req from '@/utils/request'

export default {
  props: ['sid'],
  name: 'topic_dialog',
  data () {
    return {
      sdata: [],
      bookData: [],
      total: 0,
      page: 1,
      size: 10,
      played: [],
      userInfo: null,
      pageData: null
    }
  },
  created () {
    this.oncelist()
  },
  methods: {
    getsituation (data) {
      if (!data || !data.isOver) {
        return '否'
      }
      return '是'
    },
    pagechange (val) {
      this.page = val
      this.bookData = this.pagefn(this.pageData, this.page, this.size)
    },
    pagefn (arr, page, size) {
      let offset = (page - 1) * size
      return (offset + size >= arr.length) ? arr.slice(offset, arr.length) : arr.slice(offset, offset + size)
    },
    oncelist () {
      let msg = {}
      msg.id = this.sid
      let sendData = {}
      sendData.data = msg
      sendData.fn = this.oncelistFn
      sendData.vm = this
      req.Post('user/oncelist', sendData)
    },
    oncelistFn (data) {
      if (data == null) {
      }
      let obj = data.data
      for (let i in obj) {
        obj[i].sort = JSON.parse(obj[i].sort)
        obj[i].played = JSON.parse(obj[i].played)
        obj[i].study_record = JSON.parse(obj[i].study_record)
      }
      this.sdata = obj
    },
    // 获取学习记录
    getStudy_record (data) {
      // debugger
      let sort = data.sort
      let now = parseInt(new Date().getTime() / 1000)
      this.userInfo = data
      let filter = {}
      filter.job = sort.station_id
      filter.belong_ship = sort.serve_ship
      filter.branch_id = sort.branch_id
      filter.begin = now
      filter.end = now
      filter.remove = 0
      let obj = {}
      obj.filter = filter
      let sendData = {}
      sendData.data = obj
      sendData.fn = this.getBookDataFn
      sendData.vm = this
      req.Post('ship_train/post', sendData)
    },
    getBookDataFn (data) {
      if (data == null || data.err_code !== 0) {
        // alert(data.err_msg)
        return
      }
      let user = this.userInfo
      let learnList = data.list
      let list = []
      for (let i in learnList) {
        let learn = learnList[i]
        if (learn.type !== 1) {
          continue
        }
        let job = learn.job
        if (job === 0 && learn.exclude != null) {
          let exclude = learn.exclude
          // debugger
          if (exclude.indexOf(user.sort.station_id) !== -1) { // 如果exclude 数组里边存在用户岗位 就直接跳过该书本 不添加
            continue
          }
        }
        list.push(learn)
      }
      // 处理视频
      let played = user.played
      // 看完视频才会记录
      let video = this.getmustSeeVideo(this.global.video, user.sort.station_id)
      for (let k in video) {
        let id = video[k].id
        let name = video[k].file_name
        video[k] = {
          'id': id,
          'file_name': name,
          'isOver': false,
          'index': 'N/A',
          'type': 1
        }
        for (let i in played) {
          let num = played[i]
          if (num === id) {
            video[k].isOver = true
          }
        }
        list.push(video[k])
      }
      let listX = user.study_record
      for (let i in listX) { // 已经看的书本
        for (let j in list) { // 所有书本
          let books = list[j]
          if (Number(i) === Number(books.id)) {
            let lists = listX[i]
            list[j].isOver = lists.isOver
            list[j].index = lists.index
            list[j].type = lists.type
          }
        }
      }
      if (list.length === 0) {
        return
      }
      this.pageData = list
      this.total = list.length
      this.bookData = this.pagefn(list, this.page, this.size)
    },
    // 获取当前学员必看视频
    getmustSeeVideo (arr, id) {
      let video = []
      for (let i in arr) {
        let bol = false
        for (let k in arr[i].job) {
          if (arr[i].job[k] === id) {
            bol = true
            break
          }
        }
        if (bol) {
          video.push(arr[i])
        }
      }
      return video
    },
    // 获取学习记录回调
    // resStudy_record (data) {
    //   if (data == null) {
    //     alert('网络连接错误')
    //     return
    //   }
    //   this.bookData = []
    //   let arr = []
    //   let list = JSON.parse(this.study_record)
    //   let played = (JSON.parse(this.played))
    //   if (played != null && played.length !== 0) {
    //     let video = this.global.video
    //     for (let i in played) {
    //       let num = played[i]
    //       for (let k in video) {
    //         let id = video[k].id
    //         if (num === id) {
    //           video[k].list = {
    //             'isOver': true,
    //             'index': 'N/A',
    //             'type': 1
    //           }
    //           arr.push(video[k])
    //         }
    //       }
    //     }
    //   }
    //   if (data.book) {
    //     let book = data.book
    //     for (let i in list) {
    //       for (let j in book) {
    //         let lists = list[i]
    //         let books = book[j]
    //         if (Number(i) === Number(books.id)) {
    //           books.list = lists
    //           arr.push(books)
    //         }
    //       }
    //     }
    //   }
    //   if (arr.length === 0) {
    //     return
    //   }
    //   this.pageData = arr
    //   this.total = arr.length
    //   this.bookData = this.pagefn(arr, this.page, this.size)
    // },
    getPageCount (page) {
      if (page === 'N/A') {
        return page
      }
      return page + 1 || 0
    },
    closeTip () {
      this.$parent.$parent.onceDialog = false
    }
  },
  computed: {}
}
</script>

<style scoped>

.heard {
  font-family: 'Muli', sans-serif;
  width: 950px;
  /*border: 5px solid #5b98d6;*/
  display: flex;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 8);
  position: fixed;
  min-height: 80vh;
  max-height: 80vh;
  padding: 15px;
  top: 80px;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 0 auto;
  border-width: 3px 0px 0 0;
  border-style: solid;
  border-color: #66b1ff;
}

/deep/ -webkit-scrollbar {
  width: 0px;
  height: 0px;
}

/deep/ -webkit-scrollbar-thumb {
  background-color: rgba(238, 236, 236, 0.26);
  border-radius: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/oncelist.vue